//
// Web Components.
// Audio Constants
// --------------------

/** @type {string[]} */
export const MOUSEDOWN = [
  'mousedown',
  'touchstart',
  'pointerdown'
]

/** @type {string[]} */
export const MOUSEOVER = [
  'mouseover',
  'touchstart',
  'pointerover'
]

/** @type {{ string }} */
export const MOUSELEAVE = {
  'mouseover': 'mouseleave',
  'touchstart': 'touchend',
  'pointerover': 'pointerleave'
}

/** @type {{ string }} */
export const MOUSEMOVE = {
  'mousedown': 'mousemove',
  'touchstart': 'touchmove',
  'pointerdown': 'pointermove',
  'mouseover': 'mousemove',
  'pointerover': 'pointermove'
}

/** @type {{ string }} */
export const MOUSEUP = {
  'mousedown': 'mouseup',
  'touchstart': 'touchend',
  'pointerdown': 'pointerup'
}

/** @type {{ string }} */
export const KEYS = {
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
  KEY_K: 'k',
  KEY_N: 'n',
  KEY_P: 'p',
  SHIFT: 'Shift',
  SPACE_BAR: ' '
}

/** @type {{ Number }} */
export const KEYCODES = {
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ENTER: 13,
  KEY_K: 75,
  KEY_N: 78,
  KEY_P: 80,
  SHIFT: 16,
  SPACE_BAR: 32
}
